let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("m5GRi")).then(() => parcelRequire('gq6dP'));